import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

export interface IGetModelTrainConfResponceModel {
  /**
   * 学習プログラムのバージョン
   */
  version: string;
  /**
   * 学習条件（Auto/Custom）
   */
  learnmode: string;
  /**
   * 制御モード（Direct/Indirect/）
   * 学習条件がCustomの場合は空
   */
  controlmode?: string;
}


interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIからモデル学習設定の取得が成功した場合に呼び出されます
   * @callback success
   * @param {IGetModelTrainConfResponceModel} row - モデル学習設定
   * @param {number} status - httpステータス
   */
  success: (row: IGetModelTrainConfResponceModel, status: number) => void;
}

function AxiosGet(url: string, token?: string) {
  if (token) {
    return axios.get(url, {
      headers: { Authorization: "Bearer " + token },
    });
  } else {
    return axios.get(url);
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      const data: IGetModelTrainConfResponceModel = res.data;
      params.success(
        data, res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

export interface IGetModelTrainConfParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
}

/**
 * モデル学習設定を取得します
 * @function getModelTrainConfig
 * @param {IGetModelTrainConfParams} params - モデル学習設定取得パラメータ
 */
 export function getModelTrainConfig(params: IGetModelTrainConfParams): void {
  const { authService, projectid } = params;
  const url = WebAPI.GETCONFIG_MODEL(projectid);
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosGet(url, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              getModelTrainConfigRetry401(authService, url, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosGet(url),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * モデル学習設定を取得します
 * @function getModelTrainConfigRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {ICallbackParams} params - コールバックパラメータ
 */
function getModelTrainConfigRetry401(
  authService: AuthService,
  url: string,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosGet(url, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}
